import { render, staticRenderFns } from "./CustomPageContent.vue?vue&type=template&id=39b5a0f4"
import script from "./CustomPageContent.vue?vue&type=script&lang=ts"
export * from "./CustomPageContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports